// Sentry browser SDK: error reporting + distributed tracing.
//
// Disabled unless REACT_APP_SENTRY_DSN is provided at build time (so local/dev
// builds stay offline). browserTracingIntegration auto-instruments fetch/XHR
// (axios) and attaches the `sentry-trace` / `baggage` headers to requests that
// match tracePropagationTargets — the Django backend continues that same trace,
// so a single trace spans front → back → db.
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return; // no DSN => Sentry stays inert
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    // Propagate trace headers to our API (same-origin /api + the prod domains).
    tracePropagationTargets: ['localhost', /^\/api\//, /publy-music\.(fr|com)/],
  });
}

export { Sentry };
